import React from 'react'
import PropTypes from 'prop-types'
import { useCurrentUser } from '../../../hooks'
import FastAvatar from '../../molecules/FastAvatar'

function CurrentUserAvatar ({ className, style, size }) {
  const { data: user, isLoading: isLoadingUser } = useCurrentUser()

  return (
    <FastAvatar
      className={className}
      style={style}
      isLoading={isLoadingUser}
      avatarUrl={user?.profilePictureUrl}
      size={size}
    />
  )
}

CurrentUserAvatar.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  size: PropTypes.string
}

export default CurrentUserAvatar
